import {
  ToggleButtonGroup as RACToggleButtonGroup,
  type ToggleButtonGroupProps as RACToggleButtonGroupProps,
  SelectionIndicator,
} from "react-aria-components";

export { SelectionIndicator };

export interface ToggleButtonGroupProps extends RACToggleButtonGroupProps {}

export function ToggleButtonGroup(props: ToggleButtonGroupProps) {
  return <RACToggleButtonGroup {...props} />;
}
